import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api, { errMsg } from '../services/api';
import Msg from '../components/Msg';

export default function Dashboard() {
  const [s, setS] = useState(null);
  const [msg, setMsg] = useState(null);

  useEffect(() => {
    api.get('/api/stats').then(r => setS(r.data)).catch(e => setMsg({ type: 'err', text: errMsg(e) }));
  }, []);

  return (
    <div>
      <h2>Panou</h2>
      <Msg msg={msg} />
      {!s && !msg && <p className="muted">Se încarcă…</p>}
      {s && (
        <div className="cards">
          <Link to="/cereri" className={`stat${s.pendingRequests > 0 ? ' stat-alert' : ''}`}>
            <div className="stat-n">{s.pendingRequests}</div><div>Cereri în așteptare</div>
          </Link>
          <Link to="/familii" className="stat">
            <div className="stat-n">{s.families}</div><div>Familii{s.familiesSuspended > 0 ? ` (${s.familiesSuspended} suspendate)` : ''}</div>
          </Link>
          <Link to="/utilizatori" className="stat">
            <div className="stat-n">{s.users}</div><div>Utilizatori</div>
          </Link>
          <Link to="/utilizatori" className="stat">
            <div className="stat-n">{s.usersUnverified}</div><div>Email neconfirmat</div>
          </Link>
        </div>
      )}
      <p className="muted small">Managerul arată doar date de cont. Pozițiile membrilor nu sunt vizibile aici.</p>
    </div>
  );
}
